<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useKidStore } from '@stores/kid'

import { useKidRoutes } from '@composables/routes/kid-route.hook'
import { useDisciplineInKid } from '@hooks/discipline/discipline-in-kid.hook'
import { useDisciplineLink } from '@composables/widgets/menu/discipline-link.hook'

import HeaderNavItem from '@Molecules/HeaderNavItem.vue'

defineOptions({
  name: 'LinkDisciplineEla',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const text = 'ELA'

const kidStore = useKidStore()

const {
  isRouteDisciplineEla,
  homeEla,
} = useKidRoutes()

const { isDisciplineEla } = useDisciplineInKid()

const { discount, handleClick } = useDisciplineLink({
  discipline: Discipline.ELA,
  isDiscipline: isDisciplineEla,
  isRouteDiscipline: isRouteDisciplineEla,
  homeRoute: homeEla,
  trackName: 'link_discipline_ela',
  text,
})

</script>

<template>
  <HeaderNavItem
    :layout="layout"
    icon="book-open-reader"
    :label="text"
    :href="homeEla ?? undefined"
    :selected="isRouteDisciplineEla"
    :disabled="!kidStore.hasActiveKid"
    :discount="discount"
    @click="handleClick"
  />
</template>
